import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppConfig } from 'client/app/app.config';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { LocalStorageService } from '@services/local-storage-service';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'side-face-photo-sheet',
  templateUrl: './side-face-photo-sheet.html',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
  ],
})
export class SideFaceBottomSheetComponent implements OnInit {
  leftSideImage: { image: string; side: string } | null = null;
  rightSideImage: { image: string; side: string } | null = null;
  availableImages: Array<{ image: string; side: string }> = [];

  requiredSide: string;

  constructor(
    // eslint-disable-next-line new-cap
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public appConfig: AppConfig,
    private readonly bottomSheetRef: MatBottomSheetRef,
    private localStorage: LocalStorageService,
    private readonly eventLogger: EventLoggerService,
  ) {}

  ngOnInit(): void {
    this.requiredSide = this.data.requiredSide;
    this.availableImages = this.data.availableImages ?? [];

    this.leftSideImage = this.availableImages.find(
      (img: { image: string; side: string }): boolean => img.side === this.appConfig.Shared.InstantCheckup.Type.LEFT_SIDE_FACE,
    ) || null;

    this.rightSideImage = this.availableImages.find(
      (img: { image: string; side: string }): boolean => img.side === this.appConfig.Shared.InstantCheckup.Type.RIGHT_SIDE_FACE,
    ) || null;

    const eventData = { name: 'take_other_side_photo_bottomsheet' };
    this.eventLogger.cleverTapEvent('impression', JSON.stringify(eventData));
  }

  uploadImage(): void {
    if (!this.data.callback) return

    this.localStorage.setValue('expectedFacePhoto', 'SIDE_FACE');
    this.bottomSheetRef.dismiss();
    this.data.callback(true);
    this.sendClickEvent({ name: 'take_other_side_photo' })
  }

  closedPopup(fromSkip?: boolean): void {
    this.localStorage.setValue('bothSideUploadSkipped', true)
    this.bottomSheetRef.dismiss(this.appConfig.Shared.Followup.State.SKIP);
    const eventData = {
      name: fromSkip ? 'take_other_side_photo_skipped' : 'take_other_side_photo_closed'
    };
    this.sendClickEvent(eventData)
  }

  sendClickEvent(eventData: { name: string; }): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify(eventData));
  }
}
